import { sdk } from 'src/utilities/sdk';
import { ICreditCard } from 'src/types/CreditCard';

export const getCreditCardsUrl = (
  corpId: string,
  isInternalAdminUser: boolean
): string => {
  const baseUrl = `/payments/corporate/${corpId}/credit_card`;
  return isInternalAdminUser ? `${baseUrl}/internal_admin` : baseUrl;
};

export const getCreditCards = async (
  corpId: string,
  isInternalAdminUser: boolean
): Promise<ICreditCard[]> => {
  return sdk.http.get(getCreditCardsUrl(corpId, isInternalAdminUser));
};
